"use client";

import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { useT } from "@/lib/locale";

const SHOW_THRESHOLD_PX = 1500;
const HIDE_THRESHOLD_PX = 300;

export default function BackToTopFAB() {
  const t = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => {
      const y = window.scrollY;
      if (y > SHOW_THRESHOLD_PX) setVisible(true);
      else if (y < HIDE_THRESHOLD_PX) setVisible(false);
    };

    window.addEventListener("scroll", handler, { passive: true });
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="md:hidden fixed bottom-20 right-4 z-40 w-11 h-11 rounded-full bg-brand-primary-hover text-white shadow-lg flex items-center justify-center hover:bg-brand-primary-dark transition-colors"
      aria-label={t("landing.backToTop")}
    >
      <ChevronUp size={20} aria-hidden />
    </button>
  );
}
